import React from 'react';

export function Bullet({ color }: { color: string }) {
  return (
    <svg viewBox="0 0 8 8" height={8} xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill={color} />
    </svg>
  );
}
